export const KLING_V4_MULTI_PROMPT_MODELS = new Set([
  'kling/v4/text-to-video',
  'kling/v4/image-to-video',
  'kling/v4/reference-to-video',
]);
